import { RootState } from 'store';

export const apiErrorsSelector = (state: RootState) => state.apiErrors.errors;
export const apiErrorTypesSelector = (state: RootState) => state.apiErrors.errorTypes;
export const getApiErrorsLoadingSelector = (state: RootState) => state.apiErrors.getErrorsLoading;
export const getApiErrorsSuccessSelector = (state: RootState) => state.apiErrors.getErrorsSuccess;
export const getApiErrorsErrorSelector = (state: RootState) => state.apiErrors.getErrorsError;
